import API from './'

const issue = {

	/**
	 * Get a list of issues.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`issues`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one issue details.
	 */
	one(slug, params={}, config={})
	{
		let url = API.getUrl(`issue/${slug}`)

		return API.client().get(url, { params, ...config })
	},

}

export default issue